module.exports = __webpack_public_path__ + "static/media/Casa-da-Gloria-1.39bfd270.jpg";